import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import UserDrawer from "../Components/DrawerUser";
import DashboardPage from "../Pages/DashboardPage";
import DevicesPage from "../Pages/Devices/DevicesPage";
import FAQPage from "../Pages/FAQPage";
import LoginPage from "../Pages/LoginPage";
import MediasPage from "../Pages/Medias/MediasPage";
import NotFoundPage from "../Pages/NotFoundPage";
import PlansPage from "../Pages/PlansPage";
import PlayerEntryPage from "../Pages/Player/PlayerEntryPage";
import PlayerPage from "../Pages/Player/PlayerPage";
import PlaylistEditPage from "../Pages/Playlists/PlaylistEdit";
import PlaylistsPage from "../Pages/Playlists/PlaylistsPage";
import ProductsPage from "../Pages/Products/ProductsPage";
import TemplateEditPage from "../Pages/Templates/TemplateEdit";
import TemplatesPage from "../Pages/Templates/TemplatesPage";
import UserPage from "../Pages/Users/UsersPage";
import AdminRoute from "./AdminRoute";
import ProtectedRoute from "./ProtectedRoute";
import SuperAdminRoute from "./SuperAdminRoute";


export const router = createBrowserRouter([
  {
    
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: "login",
        element: <LoginPage />
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
      {
        // /view e /tv usam o MESMO player robusto (PlayerPage):
        // 2 slots com crossfade, vídeo avança por onEnded e watchdog de recuperação.
        // O antigo PlaylistCarousel empilhava todos os vídeos em loop e não avançava.
        path: "view/:code",
        element: <PlayerPage />
      },
      {
        path: "tv",
        element: <PlayerEntryPage />
      },
      {
        path: "tv/:code",
        element: <PlayerPage />
      },
      {
        path: "",
        element: (
          <ProtectedRoute>
            <UserDrawer />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "playlists",
            element: <PlaylistsPage />,
          },
          {
            path: "playlists/edit/:id",
            element: <PlaylistEditPage />
          },
          {
            path: "media",
            element: <MediasPage />,
          },
          {
            path: "produtos",
            element: <ProductsPage />,
          },
          {
            path: "dashboard",
            element: <DashboardPage />
          },
          {
            path: "users",
            element: (
              <AdminRoute>
                <UserPage />
              </AdminRoute>
            )
          },
          {
            path: "plans",
            element: (
              <AdminRoute>
                <PlansPage />
              </AdminRoute>
            )
          },
          {
            path: "faq",
            element: <FAQPage />
          },
          {
            path: "templates",
            element: <TemplatesPage />
          },
          {
            path: "templates/edit/:id",
            element: <TemplateEditPage />
          },
          {
            path: "displays",
            element: <DevicesPage />
          }
        ],
      },
    ],
  },
]);